// src/pages/Reports/BillWiseProfitLoss/billWiseProfitLossSlice.js
import { createSlice } from "@reduxjs/toolkit";
import { fetchBillWiseProfitLoss } from "./billWiseProfitLossThunk";
import { currentDateEndTime, currentDateStartTime } from "../../../lib/functions";
import dayjs from "dayjs";

const today = dayjs();
const initialState = {
  filters: {
    customerId: null,
    filterType: "all", // "all" | "customer" | "product_summary"
    fromDate: currentDateStartTime(today),
    toDate: currentDateEndTime(today),
  },
  data: [],
  productSummary: [],
  othersReport: null,
  totals: {
    totalSold: 0,
    totalPurchased: 0,
    totalProfit: 0,
    totalDiscount: 0,
  },
  loading: false,
  error: null,
};

const billWiseProfitLossSlice = createSlice({
  name: "billWiseProfitLoss",
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchBillWiseProfitLoss.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchBillWiseProfitLoss.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;

        const { reportType, data, othersReport } = action.payload;

        if (reportType === "product_summary") {
          state.productSummary = data || [];
          state.othersReport = othersReport || null;
        } else {
          state.data = data || [];

          // calculate totals
        const totalSold = state.data.reduce(
  (sum, sale) =>
    sum +
    sale.details.reduce(
      (s, d) => s + parseFloat(d.netSoldAmount || 0),
      0
    ),
  0
);
          const totalPurchased = state.data.reduce(
            (sum, sale) =>
              sum + sale.details.reduce((s, d) => s + parseFloat(d.purchasedAmount), 0),
            0
          );
          const totalProfit = state.data.reduce(
            (sum, sale) =>
              sum +
              sale.details.reduce((s, d) => s + parseFloat(d.productProfitLoss), 0),
            0
          );
          const totalDiscount = state.data.reduce(
            (sum, sale) => sum + parseFloat(sale.item_discount || 0),
            0
          );

          state.totals = { totalSold, totalPurchased, totalProfit, totalDiscount };
        }
      })
      .addCase(fetchBillWiseProfitLoss.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Something went wrong";
      });
  },
});

export const { setFilters } = billWiseProfitLossSlice.actions;
export default billWiseProfitLossSlice.reducer;
